var _path, _path2, _circle, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M58.9 83.8H49c-1.1-5.5-6-9.7-11.8-9.7-4.3 0-8 2.2-10.2 5.5v.1c-3.6-1.8-6.9-4.3-9.7-7.2-3.4-3.4-5.3-6.5-6.1-8.5 2.2-.5 4.2-1.7 5.8-3.4 2.1-2.2 3.2-5.2 3.2-8.2v-7.2c0-8.5 2.8-16.9 8.1-23.6 7.5-9.6 18.6-15 30.6-15 10.3 0 20 4 27.3 11.3 7.3 7.3 11.3 17 11.3 27.3s-4 20-11.3 27.3a38.84 38.84 0 0 1-27.3 11.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.3 45.1c0-11.6-4.5-22.5-12.7-30.7A43.88 43.88 0 0 0 58.9 1.7c-13.3 0-25.7 6-34.2 16.7-6.1 7.7-9.3 17.2-9.3 27v7c0 3.6-2.5 7-7.5 7.3-1.2.1-2.2.9-2.2 2.1-.2 3.3 3.3 9.3 8.1 14.1 3.3 3.4 7.2 6.1 11.4 8.2a12.08 12.08 0 0 0 11.9 14.2c5.9 0 10.7-4.1 11.8-9.6H59c1.3 6.8 8.4 11.5 16 8.9 6.6-2.2 9.5-9.7 7.1-15.8 2.6-1.7 5.1-3.7 7.4-5.9a43.2 43.2 0 0 0 12.8-30.8zM58.9 83.8H49c-1.1-5.5-6-9.7-11.8-9.7-4.3 0-8 2.2-10.2 5.5v.1c-3.6-1.8-6.9-4.3-9.7-7.2-3.4-3.4-5.3-6.5-6.1-8.5 2.2-.5 4.2-1.7 5.8-3.4 2.1-2.2 3.2-5.2 3.2-8.2v-7.2c0-8.5 2.8-16.9 8.1-23.6 7.5-9.6 18.6-15 30.6-15 10.3 0 20 4 27.3 11.3 7.3 7.3 11.3 17 11.3 27.3s-4 20-11.3 27.3a38.84 38.84 0 0 1-27.3 11.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.2,
    cy: 35.5,
    r: 4.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.2,
    cy: 35.5,
    r: 4.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7 51.3c-.4-.8-1.3-1.4-2.2-1.4a2.4 2.4 0 0 0-2.2 3.4c3.1 6.5 9.7 11.1 17.5 11.1s14.4-4.5 17.5-11.1c.7-1.6-.4-3.4-2.2-3.4H79c-.9 0-1.7.5-2.1 1.4-2.3 4.9-7.3 8.3-13.1 8.3S53 56.2 50.7 51.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaze);
export default __webpack_public_path__ + "static/media/waze.1f443635f0b240134d41474f6dd4ab12.svg";
export { ForwardRef as ReactComponent };